import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ModalComponent } from '@geekbears/ngx-gb-ui-kit';
import { Store } from '@ngrx/store';

import { AccountSetupCompleteModal } from '../account-setup-complete/account-setup-complete.modal';

@Component({
  selector: 'app-sing-up-modal',
  templateUrl: './sing-up-modal.modal.html',
  styleUrls: ['./sing-up-modal.modal.scss'],
})
export class SingUpModalModal extends ModalComponent implements OnInit {
  fromMobile: string = '';
  returnUrl: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialogRef: MatDialogRef<AccountSetupCompleteModal>
  ) {
    super();
    this.fromMobile = localStorage.getItem('from_mobile') || '';
    this.returnUrl = localStorage.getItem('return_url') || '';
  }

  navigateLogin() {
    if (this.fromMobile == 'true') {
      this.dialogRef.close();
    } else {
      setTimeout(() => {
        this.dialogRef.close();
        // this.router.navigateByUrl(`/dashboard/home`);
      }, 500);
    }

    this.closeModal();
  }

  clearStorage() {
    localStorage.removeItem('from_mobile');
    localStorage.removeItem('return_url');
  }

  ngOnInit(): void {}
  closeModal() {
    this.dialogRef.close();
  }
  backToTheApp() {
    this.dialogRef.close();
  }
  closeWindow() {
    window.close();
  }
}
